export interface PcmProcessorConfig {
  sampleRate?: number;
  channels?: number;
  shouldRecordAudio?: boolean;
  fileName?: string;
  fileExtension?: string;
}

export interface RecordingStatus {
  isRecording: boolean;
  currentDuration: number;
}

export interface PcmData {
  sampleRate: number;
  channels: number;
  buffer: Float32Array;
  frameLength: number;
  recordingStatus?: RecordingStatus;
}

export interface RecordingResult {
  recordingPath?: string;
  error?: string;
}

export interface PcmProcessorError {
  error: string;
}
